import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import moment from 'moment';
import { forkJoin } from 'rxjs';
import { RoleType } from 'src/app/enum/role-type';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { ReportService } from 'src/app/services/report.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-shop-orders-report',
    templateUrl: './shop-orders-report.component.html',
    styleUrls: ['./shop-orders-report.component.scss']
})
export class ShopOrdersReportComponent implements OnInit {
    ShopOrderReportForm: FormGroup;
    toMinDate: Date;
    toMaxDate: Date;
    @ViewChild('startDate') startDateDatePicker: MatDatepicker<Date>;
    @ViewChild('endDate') endDateDatePicker: MatDatepicker<Date>;
    orderStatusList: any = []
    filteredList1: any = []
    LoginRoleId: any;
    sessionDataString: any;
    userListUnEncryptedCustReport: string[];
    serviceQueue: any = []
    applicationStatusTypeList: any;
    filteredList2: any;
    lineItemStatusList: any = [];

    constructor(
        private fb: FormBuilder,
        private reportService: ReportService,
        private sessionService: UserSessionService,
        private lookupDataService: LookupDataServiceService
    ) {
        this.sessionDataString = JSON.parse(localStorage.getItem(
            this.sessionService.localStorageSessionKey));
    }


    ngOnInit(): void {
        this.init()
        if (this.sessionDataString.roletype == RoleType.Admin || this.sessionDataString.roletype == RoleType.SuperAdmin || this.sessionDataString.roletype == RoleType.Staff) {
            this.loadServiceQueue();
            this.executeServiceQueue();
        }
    }
    init() {
        this.ShopOrderReportForm = this.fb.group({
            startDate: [null, Validators.required],
            endDate: [null, Validators.required],
            orderStatus: [null],
            lineItemStatus: [null],
        });
    }
    Reset() {
        this.ShopOrderReportForm.reset()
    }
    openStartDateDatePicker() {
        this.startDateDatePicker.open();
    }

    openEndDateDatePicker() {
        this.endDateDatePicker.open();
        this.toMinDate = this.ShopOrderReportForm.controls["startDate"].value;
        // this.toMaxDate = this.addMonths(this.toMinDate, 3);
    }
    loadServiceQueue() {
        this.serviceQueue.push(this.lookupDataService.getShoppingOrderStatus());
        this.serviceQueue.push(this.lookupDataService.getOrderLineItemStatus());
    }
    executeServiceQueue() {
        forkJoin(this.serviceQueue).subscribe((serviceResponse) => {
            debugger
            this.orderStatusList = serviceResponse[0];
            this.lineItemStatusList = serviceResponse[1];

            this.orderStatusList = this.orderStatusList.sort((a, b) => a.value.localeCompare(b.value));
            this.filteredList1 = this.orderStatusList.slice()

            this.lineItemStatusList = this.lineItemStatusList.sort((a, b) => a.value.localeCompare(b.value));
            this.filteredList2 = this.lineItemStatusList.slice()
        });
    }


    generateExcel() {
        console.log(this.ShopOrderReportForm.value);

        if (this.ShopOrderReportForm.value.orderStatus && this.ShopOrderReportForm.value.lineItemStatus) {
            Swal.fire({
                icon: 'warning',
                title: 'Please select either Order Status or Line Item Status',
                position: 'center',

            })
            this.ShopOrderReportForm.get('orderStatus').setValue('')
            this.ShopOrderReportForm.get('lineItemStatus').setValue('')
            return
        }

        if (this.ShopOrderReportForm.value.startDate > this.ShopOrderReportForm.value.endDate) {
            if (this.ShopOrderReportForm.value.endDate) {
                Swal.fire({
                    icon: 'warning',
                    title: 'End Date should be greater than Start Date',
                    position: 'center',

                })
            }
            return

        }
        else if (!this.ShopOrderReportForm.value.startDate && !this.ShopOrderReportForm.value.endDate) {
            Swal.fire({
                icon: 'warning',
                title: 'From date and To date should not be empty',
                position: 'center',

            })
            return

        }
        else if (!this.ShopOrderReportForm.value.startDate) {
            Swal.fire({
                icon: 'warning',
                title: 'From date should not be empty',
                position: 'center',

            })
            return

        }
        else if (!this.ShopOrderReportForm.value.endDate) {
            Swal.fire({
                icon: 'warning',
                title: 'End date should not be empty',
                position: 'center',

            })
            return

        }
        else {
            var filterSearch: any = {};
            var start = moment(this.ShopOrderReportForm.value.startDate._d).format("YYYY/MM/DD");
            var end = moment(this.ShopOrderReportForm.value.endDate._d).format("YYYY/MM/DD");

            filterSearch = { startDate: start, endDate: end, orderStatus: this.ShopOrderReportForm.value.orderStatus, lineItemStatus: this.ShopOrderReportForm.value.lineItemStatus };
            console.log(filterSearch);

            this.reportService.getShopOrdersReport(filterSearch).subscribe((data) => {
                if (data) {
                    const linkSource = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64, ' + data;
                    const downloadLink = document.createElement('a');
                    const fileName = 'ShopOrdersReport.xls';
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                }
            });
        }


    }

    checkvalidation() {
        if (this.ShopOrderReportForm.value.lineItemStatus && this.ShopOrderReportForm.value.orderStatus) {
                this.ShopOrderReportForm.controls['lineItemStatus'].setValue(null)
                this.ShopOrderReportForm.controls['orderStatus'].setValue(null)

            Swal.fire({
                icon: 'warning',
                title: 'You can Either select Order Status or Line Item Status',
                position: 'center',

            })
            return
        }

    }

}

